import {useParams} from 'react-router-dom';
import {useFetchCompleteList} from '../../../../../../../hooks/fetch-all-items';
import {EntityActivitiesRepository} from '../../../../../../../repositories/entity-activities';

export function useFetchActivitiesGroupTypes(
  activitiesSectorId: string,
  activitiesGroupId: string
) {
  const {entityId} = useParams<{entityId: string}>();
  const {items, isLoading, error} = useFetchCompleteList({
    fetchFunction: () => {
      return EntityActivitiesRepository.instance.getAllTypes(
        entityId,
        activitiesSectorId,
        activitiesGroupId
      );
    },
    deps: [entityId, activitiesSectorId, activitiesGroupId],
  });

  return {
    items,
    isLoading,
    error,
  };
}
